var PaymentModeValidate = $.extend({/* PaymentModeValidate */}, BaseComponent, {

	componentSelector: '#form-payment-mode-modification',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				'payment-type': {
					required: true
				},
				'type-fee-option': {
					required: true
				},
				'percentage-input': {
					required: true
				},
				'amount-input': {
					required: true
				}
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
				if (element.attr('name') == 'payment-type') {
                    error.insertAfter((element).parents('.options-type').find('> div:last-child'));
                } else if (element.attr('name') == 'type-fee-option') {
                    error.insertAfter((element).parents('.secondary-options').find('> div:last-child'));
                } else if (element.siblings('.input-units').length > 0) {
                	error.insertAfter(element.siblings('.input-units'));
                } else {
                    error.insertAfter(element);
                }
            }
		});

		$(element).find('#payment-mode-modification-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));
	}

})